/** URL base (origen + subruta, si el panel vive en una) desde la que se está
 * usando el panel ahora mismo -- se deriva de <base href> en vez de un valor
 * fijo por build, porque el mismo build corre en más de un dominio a la vez
 * (p. ej. admin.tusala.net y el hosting temporal en desitsystem.com), y cada
 * enlace de recuperación de contraseña debe apuntar al dominio real que el
 * usuario está usando, no a uno fijo de antemano. */
export const currentFrontendBaseUrl = (): string => document.baseURI.replace(/\/$/, '');
